// extracted by mini-css-extract-plugin
export default {"container":"CareerQuizSubmission_container__w0fND"};